"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  timezoneToDropdownItem: true
};
exports.timezoneToDropdownItem = exports.default = void 0;

var _preact = require("preact");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _Button = _interopRequireDefault(require("../../../shared/uikit/Button"));

var _DropdownText = require("./DropdownText");

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var timezoneToDropdownItem = function timezoneToDropdownItem(timezone) {
  return {
    value: timezone.value,
    title: timezone.title,
    variant: 'primary'
  };
};

exports.timezoneToDropdownItem = timezoneToDropdownItem;

var TimezoneSelector = function TimezoneSelector(_ref) {
  var timezones = _ref.timezones,
      selected = _ref.selected,
      onChange = _ref.onChange,
      error = _ref.error,
      triggerClassName = _ref.triggerClassName,
      inputLabel = _ref.inputLabel;
  return (0, _preact.h)("div", {
    className: "timezone-selector-wrapper"
  }, (0, _preact.h)(_DropdownControl.default, {
    closeOnDropdownClick: true,
    triggerClass: triggerClassName,
    align: "adjust",
    trigger: (0, _preact.h)(_Button.default, {
      title: (0, _preact.h)(_DropdownText.DropdownText, {
        timezones: timezones,
        selected: selected,
        label: inputLabel
      }),
      className: (0, _classnames.default)('timezone-selector', 'qa-timezone-selector', {
        'validation-error': error,
        'no-timezone-selected-message': !selected
      }),
      icon: "chevronDown"
    }),
    items: timezones.map(function (timezone) {
      return _objectSpread(_objectSpread({}, timezoneToDropdownItem(timezone)), {}, {
        onClick: function onClick(event) {
          var target = event.target;
          onChange(target.getAttribute('value'));
        }
      });
    }),
    hasSearch: true
  }));
};

var _default = TimezoneSelector;
exports.default = _default;